import { Component } from '@opten/compiler/metadata/component';
import stickybits from 'stickybits';

@Component({ className: 'js-sticky' })
export class StickyComponent {
	constructor(private element: HTMLElement) {
		stickybits(this.element, {
			parentClass: 'js-sticky-parent',
			stickyChangeClass: 'is-sticky-change',
			stickyClass: 'is-sticky',
			stuckClass: 'is-stuck',
			useStickyClasses: true,
			verticalPosition: 'bottom',
			// stickyBitStickyOffset: 150,
			// useFixed: true,
		});
	}
}
